import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5468d46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Tittel", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col z-9"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Forelder kategori", -1))
const _hoisted_8 = { class: "flex gap-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-2xl" }, "Er du sikker?", -1))
const _hoisted_10 = { class: "font-bold italic" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Sletting av denne kategorien vil sette alle underkategorier og FAQer til slettet, men det er mulig å hente igjen. ", -1))
const _hoisted_12 = { class: "flex justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidationFormErrors = _resolveComponent("ValidationFormErrors")!
  const _component_levels_select = _resolveComponent("levels-select")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_HcButton = _resolveComponent("HcButton")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ValidationFormErrors, {
        errors: _ctx.form.errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
          type: "text",
          id: "title",
          class: "form-input"
        }, null, 512), [
          [_vModelText, _ctx.form.title]
        ]),
        (_ctx.form.errors.title)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.form.errors.title), 1))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.category || _ctx.category.options?.length == 0 || _ctx.category.parent_id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_levels_select, {
              limit: 100,
              placeholder: 'Velg kategori',
              options: _ctx.categories as any,
              onSelectOption: _ctx.selectOption,
              modelValue: _ctx.form.parent_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.parent_id) = $event))
            }, null, 8, ["options", "onSelectOption", "modelValue"]),
            _createTextVNode(" " + _toDisplayString(_ctx.form.errors.parent_id), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_HcButton, {
          disabled: _ctx.form.processing,
          type: "button",
          onClick: _withModifiers(_ctx.submit, ["stop"]),
          class: "flex gap-1 items-center",
          color: "green"
        }, {
          default: _withCtx(() => [
            (_ctx.form.processing)
              ? (_openBlock(), _createBlock(_component_SvgIcon, {
                  key: 0,
                  type: "mdi",
                  class: "animate-spin h-5 w-5",
                  path: _ctx.loadingIcon
                }, null, 8, ["path"]))
              : (_openBlock(), _createBlock(_component_SvgIcon, {
                  key: 1,
                  type: "mdi",
                  path: _ctx.saveIcon
                }, null, 8, ["path"])),
            _createTextVNode(" Lagre ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        (_ctx.category)
          ? (_openBlock(), _createBlock(_component_HcButton, {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDeleteModal = true)),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.showDeleteModal = true), ["enter"])),
              disabled: _ctx.form.processing,
              type: "button",
              class: "flex gap-1 items-center",
              color: "red"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  type: "mdi",
                  path: _ctx.deleteIcon
                }, null, 8, ["path"]),
                _createTextVNode(" Slett ")
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_HcButton, {
          onClick: _ctx.cancelCreate,
          onKeyup: _withKeys(_ctx.cancelCreate, ["enter"]),
          disabled: !_ctx.form.isDirty || _ctx.form.processing,
          type: "button",
          color: "gray"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Tilbakestill ")
          ]),
          _: 1
        }, 8, ["onClick", "onKeyup", "disabled"])
      ])
    ]),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteCategory && _ctx.deleteCategory(...args)), ["prevent"])),
              class: "flex flex-col gap-2 p-4"
            }, [
              _hoisted_9,
              _createElementVNode("p", null, [
                _createTextVNode(" Er du sikker på at du vil slette kategorien "),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.category?.label), 1),
                _createTextVNode(" ? ")
              ]),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_HcButton, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDeleteModal = false)),
                  onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.showDeleteModal = false), ["enter"])),
                  color: "gray"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Avbryt ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_HcButton, {
                  color: "red",
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Slett")
                  ]),
                  _: 1
                })
              ])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}